export const BLOCK_SCREEN = 'BLOCK_SCREEN';
export const UNBLOCK_SCREEN = 'UNBLOCK_SCREEN';
export const ACTIVATE_NEXT_BUTTON = 'ACTIVATE_NEXT_BUTTON';
export const DEACTIVATE_NEXT_BUTTON = 'DEACTIVATE_NEXT_BUTTON';
export const UNMOUNT_SCREEN = 'UNMOUNT_SCREEN';
export const GREY_OUT_OK_BUTTON = 'GREY_OUT_OK_BUTTON';
export const COLOR_IN_OK_BUTTON = 'COLOR_IN_OK_BUTTON';
export const GREY_OUT_SCREEN = 'GREY_OUT_SCREEN';
export const COLOR_IN_SCREEN = 'COLOR_IN_SCREEN';
export const ENABLE_DOWN_BUTTON = 'ENABLE_DOWN_BUTTON';
export const DISABLE_DOWN_BUTTON = 'DISABLE_DOWN_BUTTON';
export const HIGHLIGHT_DOWN_BUTTON = 'HIGHLIGHT_DOWN_BUTTON';
export const DEHIGHLIGHT_DOWN_BUTTON = 'DEHIGHLIGHT_DOWN_BUTTON';
export const ENABLE_GO_BACK_BUTTON = 'ENABLE_GO_BACK_BUTTON';
export const DISABLE_GO_BACK_BUTTON = 'DISABLE_GO_BACK_BUTTON';
export const OPEN_READING_REMINDER_POPUP = 'OPEN_READING_REMINDER_POPUP';
export const CLOSE_READING_REMINDER_POPUP = 'CLOSE_READING_REMINDER_POPUP';
export const SET_IS_SCROLL_BUTTON_CLICKED = 'SET_IS_SCROLL_BUTTON_CLICKED';
export const ENABLE_TEXT_PANE_SCROLL = 'ENABLE_TEXT_PANE_SCROLL';
export const DISABLE_TEXT_PANE_SCROLL = 'DISABLE_TEXT_PANE_SCROLL';
export const DEACTIVATE_READY_FOR_NEXT_SCREEN = 'DEACTIVATE_READY_FOR_NEXT_SCREEN';
export const SET_CONFIRM_POPUP_VISIBILITY = 'SET_CONFIRM_POPUP_VISIBILITY';
export const SHOW_LOGOUT_MODAL = 'SHOW_LOGOUT_MODAL';
export const HIDE_LOGOUT_MODAL = 'HIDE_LOGOUT_MODAL';
export const SET_IS_FILE_LOADING_FAILED = 'SET_IS_FILE_LOADING_FAILED';
export const TOGGLE_POINTER_CLICK = 'TOGGLE_POINTER_CLICK';
export const SET_POINTER_POSITION = 'SET_POINTER_POSITION';
export const TOGGLE_POINTER_VISIBILITY = 'TOGGLE_POINTER_VISIBILITY';
export const TOGGLE_CIRCLE_BUTTONS = 'TOGGLE_CIRCLE_BUTTONS';
export const TOGGLE_SECONDS_TIMER = 'TOGGLE_SECONDS_TIMER';
export const SET_SECONDS_TIMER = 'SET_SECONDS_TIMER';
export const SET_NEXT_BUTTON_CLICKABLE = 'SET_NEXT_BUTTON_CLICKABLE';
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE';
export const SHOW_HELP_POPUP = 'SHOW_HELP_POPUP';
export const HIDE_HELP_POPUP = 'HIDE_HELP_POPUP';
export const OPEN_TRC_PRACTICE_POPUP = 'OPEN_TRC_PRACTICE_POPUP';
export const CLOSE_TRC_PRACTICE_POPUP = 'CLOSE_TRC_PRACTICE_POPUP';
export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const SET_IS_EXTERNAL_URL_SOURCE_PRESENT = 'SET_IS_EXTERNAL_URL_SOURCE_PRESENT';
export const SET_BENCHMARK_MODE_URL_STATUS = 'SET_BENCHMARK_MODE_URL_STATUS';
export const SET_AR_LANGUAGE = 'SET_AR_LANGUAGE';
export const SET_BENCHMARK_ID = 'SET_BENCHMARK_ID';
export const SET_SHOULD_ENABLE_CAPTIONS = 'SET_SHOULD_ENABLE_CAPTIONS';
export const SET_SHOULD_DISPLAY_CAPTION = 'SET_SHOULD_DISPLAY_CAPTION';
export const SHOW_PAUSE_BUTTON = 'SHOW_PAUSE_BUTTON';
export const SET_PAUSE_BUTTON_ACTIVE = 'SET_PAUSE_BUTTON_ACTIVE';
export const SET_PAUSE_BUTTON_INACTIVE = 'SET_PAUSE_BUTTON_INACTIVE';
export const SHOW_SETTINGS_POPUP = 'SHOW_SETTINGS_POPUP';
export const HIDE_SETTINGS_POPUP = 'HIDE_SETTINGS_POPUP';

export const blockScreen = () => ({
    type: BLOCK_SCREEN,
});

export const unblockScreen = () => ({
    type: UNBLOCK_SCREEN,
});

export const activateNextButton = () => ({
    type: ACTIVATE_NEXT_BUTTON,
});

export const deactivateNextButton = () => ({
    type: DEACTIVATE_NEXT_BUTTON,
});

export const deactivateReadyForNextScreen = () => ({
    type: DEACTIVATE_READY_FOR_NEXT_SCREEN,
});

export const unmountScreen = () => ({
    type: UNMOUNT_SCREEN,
});

export const greyOutOkButton = () => ({
    type: GREY_OUT_OK_BUTTON,
});

export const colorInOkButton = () => ({
    type: COLOR_IN_OK_BUTTON,
});

export const greyOutScreen = () => ({
    type: GREY_OUT_SCREEN,
});

export const colorInScreen = () => ({
    type: COLOR_IN_SCREEN,
});

export const enableDownButton = () => ({
    type: ENABLE_DOWN_BUTTON,
});

export const disableDownButton = () => ({
    type: DISABLE_DOWN_BUTTON,
});

export const highlightDownButton = () => ({
    type: HIGHLIGHT_DOWN_BUTTON,
});

export const dehighlightDownButton = () => ({
    type: DEHIGHLIGHT_DOWN_BUTTON,
});

export const enableGoBackButton = () => ({
    type: ENABLE_GO_BACK_BUTTON,
});

export const disableGoBackButton = () => ({
    type: DISABLE_GO_BACK_BUTTON,
});

export const openReadingReminderPopup = () => ({
    type: OPEN_READING_REMINDER_POPUP,
});

export const closeReadingReminderPopup = () => ({
    type: CLOSE_READING_REMINDER_POPUP,
});

export const setIsScrollButtonClicked = (isClicked) => ({
    type: SET_IS_SCROLL_BUTTON_CLICKED,
    isClicked,
});

export const enableTextPaneScroll = () => ({
    type: ENABLE_TEXT_PANE_SCROLL,
});

export const disableTextPaneScroll = () => ({
    type: DISABLE_TEXT_PANE_SCROLL,
});

export const setConfirmPopupVisibility = (isVisible) => ({
    type: SET_CONFIRM_POPUP_VISIBILITY,
    isVisible,
});

export const showLogoutModal = () => ({
    type: SHOW_LOGOUT_MODAL,
});

export const hideLogoutModal = () => ({
    type: HIDE_LOGOUT_MODAL,
});

export const setIsFileLoadingFailed = (isFileLoadingFailed) => ({
    type: SET_IS_FILE_LOADING_FAILED,
    isFileLoadingFailed,
});

export const togglePointerClick = () => ({
    type: TOGGLE_POINTER_CLICK,
});

export const setPointerPosition = (position) => ({
    type: SET_POINTER_POSITION,
    position,
});

export const setNextButtonClickable = (isClickable) => ({
    type: SET_NEXT_BUTTON_CLICKABLE,
    isClickable,
});

export const animatePointerPosition = (position, duration) => (dispatch) => new Promise((resolve) => {
    dispatch(setPointerPosition(position));
    setTimeout(resolve, duration);
});

export const animatePointerClick = (duration) => (dispatch) => {
    dispatch(togglePointerClick());
    return new Promise((resolve) => {
        setTimeout(() => {
            dispatch(togglePointerClick());
            resolve();
        }, duration);
    });
};

export const togglePointerVisibility = () => ({
    type: TOGGLE_POINTER_VISIBILITY,
});

export const toggleCircleButtons = () => ({
    type: TOGGLE_CIRCLE_BUTTONS,
});

export const toggleSecondsTimer = () => ({
    type: TOGGLE_SECONDS_TIMER,
});

export const setSecondsTimer = (isActive) => ({
    type: SET_SECONDS_TIMER,
    isActive,
});

export const setCurrentLanguage = (language) => {
    return {
        type: SET_CURRENT_LANGUAGE,
        language,
    };
};

export const showHelpPopup = () => ({
    type: SHOW_HELP_POPUP,
});

export const hideHelpPopup = () => ({
    type: HIDE_HELP_POPUP,
});

export const openTRCPracticePopup = () => ({
    type: OPEN_TRC_PRACTICE_POPUP,
});

export const closeTRCPracticePopup = () => ({
    type: CLOSE_TRC_PRACTICE_POPUP,
});

export const showSpinner = () => ({
    type: SHOW_SPINNER,
});

export const hideSpinner = () => ({
    type: HIDE_SPINNER,
});

export const setExternalURLStatus = () => ({
    type: SET_IS_EXTERNAL_URL_SOURCE_PRESENT,
});

export const setBenchmarkModeStatus = (benchmarkMode) => ({
    type: SET_BENCHMARK_MODE_URL_STATUS,
    benchmarkMode,
});

export const setArLanguage = (language) => ({
    type: SET_AR_LANGUAGE,
    payload: language,
});

export const setBenchmarkId = (id) => ({
    type: SET_BENCHMARK_ID,
    id,
});

export const setShouldEnableCaptions = () => ({
    type: SET_SHOULD_ENABLE_CAPTIONS,
});

export const setShouldDisplayCaption = shouldDisplayCaption => ({
    type: SET_SHOULD_DISPLAY_CAPTION,
    payload: shouldDisplayCaption,
});

export const showPauseButton = () => ({
    type: SHOW_PAUSE_BUTTON,
});

export const setPauseButtonActive = () => ({
    type: SET_PAUSE_BUTTON_ACTIVE,
});

export const setPauseButtonInactive = () => ({
    type: SET_PAUSE_BUTTON_INACTIVE,
});

export const showSettingsPopup = () => ({
    type: SHOW_SETTINGS_POPUP,
});
export const hideSettingsPopup = () => ({
    type: HIDE_SETTINGS_POPUP,
});
